import store from "@/store";

class DZModelSystemConfig {

  onRoutes = "";

  menu_main = [
    {
      id: "101",
      name: "审核管理",
      icon: "el-icon-coordinate",
      path: "/",
      childList: [
        {
          id: "10101",
          name: "土地管理",
          icon: "el-icon-monitor",
          path: "/land/list",
        },
        {
          id: "10102",
          name: "民宿管理",
          icon: "el-icon-monitor",
          path: "/homestay/list",
        },
        {
          id: "10103",
          name: "需求管理",
          icon: "el-icon-monitor",
          path: "/demand/list",
        },
        {
          id: "10104",
          name: "招商管理",
          icon: "el-icon-monitor",
          path: "/courtship/list",
        }
      ]
    },
    {
      id: "105",
      name: "评测管理",
      icon: "el-icon-pie-chart",
      path: "/review",
      childList: [
        {
          id: "10501",
          name: "土地评测",
          icon: "el-icon-monitor",
          path: "/land/review",
        }
      ]
    },
    {
      id: "201",
      name: "用户管理",
      icon: "el-icon-user",
      path: "/user",
      childList: [
        {
          id: "20101",
          name: "普通用户",
          path: "/user/normallist",
        },
        {
          id: "20102",
          name: "政企用户",
          path: "/user/zqlist",
        }
      ]
    },
    {
      id: "301",
      name: "代理商管理",
      icon: "el-icon-sell",
      path: "/agent",
      /*childList: [
      {
        id: "30101",
        name: "代理商列表",
        icon: "el-icon-monitor",
        path: "/agent/list",
      },
      {
        id: "30102",
        name: "代理商审核",
        icon: "el-icon-monitor",
        path: "/agent/auditing",
      }
      ]*/
    },
    {
      id: "401",
      name: "字典管理",
      icon: "el-icon-discount",
      path: "/dic/type"
    },
    {
      id: "501",
      name: "系统管理",
      icon: "el-icon-set-up",
      path: "/system",
      childList: [
        {
          id: "50101",
          name: "权限管理",
          icon: "el-icon-monitor",
          path: "/system/menu",
        },
        {
          id: "50102",
          name: "角色管理",
          icon: "el-icon-monitor",
          path: "/system/role",
        },
        {
          id: "50103",
          name: "管理员管理",
          icon: "el-icon-monitor",
          path: "/system/admin",
        },
      ]
    },
    {
      id: "601",
      name: "订单管理",
      icon: "el-icon-document",
      path: "/order",
      childList: [
        {
          id: "60101",
          name: "土地订单",
          icon: "el-icon-monitor",
          path: "/land/order"
        },
        {
          id: "60102",
          name: "民宿订单",
          icon: "el-icon-monitor",
          path: "/homestay/order"
        }
      ]
    },
    {
      id: "701",
      name: "资讯管理",
      icon: "el-icon-headset",
      path: "/information",
      childList: [
        {
          id: "70101",
          name: "资讯列表",
          icon: "el-icon-monitor",
          path: "/information/list",
        },
        {
          id: "70102",
          name: "分类管理",
          icon: "el-icon-monitor",
          path: "/information/type",
        }
      ]
    },
    {
      id: "801",
      name: "百科管理",
      icon: "el-icon-reading",
      path: "/wikipedia",
      childList: [
        {
          id: "80101",
          name: "百科列表",
          icon: "el-icon-monitor",
          path: "/wikipedia/list",
        },
        {
          id: "80102",
          name: "分类管理",
          icon: "el-icon-monitor",
          path: "/wikipedia/type",
        }
      ]
    },
    {
      id: "805",
      name: "Banner管理",
      icon: "el-icon-data-board",
      path: "/banner"
    },
    {
      id: "901",
      name: "系统设置",
      icon: "el-icon-cpu",
      path: "/setting",
      childList: [
        {
          id: "90101",
          name: "开通城市",
          icon: "el-icon-monitor",
          path: "/setting/city",
        },
        {
          id: "90102",
          name: "系统参数",
          icon: "el-icon-monitor",
          path: "/setting/set",
        }
      ]
    },
    {
      id: "12",
      name: "支付记录",
      icon: "el-icon-data-board",
      path: "/paylog"
    },
  ];

  constructor() { }

  initAuthData(success: (res: any) => void) {
    let arr = store.state.user.menus
    let all_menus = [...this.menu_main]
    let my_menus = []
    all_menus.forEach(m => {
      if (arr.indexOf(m.id) != -1) {
        let obj = { id: "", name: "", icon: "", path: "", childList: [] }
        obj.id = m.id
        obj.name = m.name
        obj.icon = m.icon
        obj.path = m.path
        if (m.childList && m.childList.length != 0) {
          m.childList.forEach(c => {
            if (arr.indexOf(c.id) != -1) {
              obj.childList.push(c)
            }
          })
        }
        my_menus.push(obj)
      }
    })
    return my_menus
  }
}

export default DZModelSystemConfig;
